const mutations = {
    setTableItems(state, payload) {
      state.tableItems = payload;
    }, 
    setMenuItems(state, payload) {
      state.menuItems = payload;
    },
    setOptionSelect(state, payload) {
      state.optionSelect = payload;
    },
    setCurrentPage(state, payload){
      state.currentPage = payload;
    },
    setMobile(state, payload) {
      console.log("mobile: ", payload)
      state.mobile = payload
    },
    setShowPopup(state){
      state.showPopup = !state.showPopup;
    },
    setActiveForm(state, payload) {
      state.activeForm = payload;
    },
    setActiveEl(state, payload) {
      state.activeEl = payload;
    }
  };

  export default mutations;  